// extracted by mini-css-extract-plugin
export default {"assetRow":"ums-asset_assetRow__pTELE"};